<template>
  <div>
    <v-card class="pa-2" color="grey lighten-3">
      <v-row>
        <v-col cols="12" md="4">
          <VueAutonumeric v-model="cuadre.valorasignaciones" dense label="Asignaciones Gas (Galones)" outlined readonly
          :an-options="{ decimalPlaces: 2 }">
            <template v-slot:prepend>
              <i class="fa fa-free-code-camp" style="font-size: 1.3rem; width: 1.3rem"></i>
            </template>
          </VueAutonumeric>

          <VueAutonumeric v-model="cuadre.donaciones" dense label="Donaciones Gas (Galones)" outlined readonly
          :an-options="{ decimalPlaces: 2 }">
            <template v-slot:prepend>
              <i class="fa fa-free-code-camp" style="font-size: 1.3rem; width: 1.3rem"></i>
            </template>
          </VueAutonumeric>

          <VueAutonumeric v-model="cuadre.pruebasmetro" dense label="Pruebas Gas (Galones)" outlined readonly
          :an-options="{ decimalPlaces: 2 }">
            <template v-slot:prepend>
              <i class="fa fa-free-code-camp" style="font-size: 1.3rem; width: 1.3rem"></i>
            </template>
          </VueAutonumeric>
        </v-col>

        <v-col cols="12" md="4">

          <!-- <VueAutonumeric
            v-model="cuadre.inventariofisico"
            :an-options="{ decimalPlaces: 2 }"
            dense
            label="Inventario Inicial (Galones)"
            outlined
            readonly
          >
            <template v-slot:prepend>
              <i class="fa fa-cubes" style="font-size: 1.3rem; width: 1.3rem"></i>
            </template>
          </VueAutonumeric> -->
<!-- style="font-size: 13px;" -->
<AutoNumericNuevoWithOptions id="formdisabledInput"
                                                     v-model.number="cuadre.inventariofisico"
                                                     :label="`Inventario Inicial (Galones)`" :rules="[$rules.Numericc]"
                                                     autocomplete="off"
                                                     dense 
                                                     outlined 
                                                     v-bind:options="{ 'decimalPlaces': 2}"
                                                          >
                                                          
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-cubes"></i>
                          </template>
                        </AutoNumericNuevoWithOptions>



          <VueAutonumeric
            v-model="cuadre.comprasdomestico"
            :an-options="{ decimalPlaces: 2, minimumValue: 0, emptyInputBehavior: 0 }"
            dense
            label="Compras Gas (Galones)"
            outlined
          >
            <template v-slot:prepend>
              <i class="fa fa-free-code-camp" style="font-size: 1.3rem; width: 1.3rem"></i>
            </template>
          </VueAutonumeric>

          <VueAutonumeric
            v-model="cuadre.salidasgas"
            :an-options="{ decimalPlaces: 2, minimumValue: 0, emptyInputBehavior: 0 }"
            dense
            label="Salidas Gas (Galones)"
            outlined
          >
            <template v-slot:prepend>
              <i class="fa fa-free-code-camp" style="font-size: 1.3rem; width: 1.3rem"></i>
            </template>
          </VueAutonumeric>
        </v-col>

        <v-col cols="12" md="4">
          <VueAutonumeric
            v-model="existenciaEnLibro"
            :an-options="{ decimalPlaces: 2 }"
            dense
            label="Existencia en Libro (Galones)"
            outlined
            readonly
          >
            <template v-slot:prepend>
              <i class="fa fa-wpforms" style="font-size: 1.3rem; width: 1.3rem"></i>
            </template>
          </VueAutonumeric>

          <VueAutonumeric
            v-model="cuadre.inventariofisicofinal"
            :an-options="{ decimalPlaces: 2, minimumValue: 0, emptyInputBehavior: 0 }"
            dense
            label="Inventario Fisico Final (Galones)"
            outlined
          >
            <template v-slot:prepend>
              <i class="fa fa-cubes" style="font-size: 1.3rem; width: 1.3rem"></i>
            </template>
          </VueAutonumeric>

          <VueAutonumeric
            v-model="totalDiferencia"
            :an-options="{ decimalPlaces: 2 }"
            dense
            label="Diferencia (INFO)"
            outlined
            readonly
          >
            <template v-slot:prepend>
              <i class="fa fa-delicious" style="font-size: 1.3rem; width: 1.3rem"></i>
            </template>
          </VueAutonumeric>
        </v-col>
      </v-row>
    </v-card>
    <!--- Fin Informacion en row inferior ---->
  </div>
</template>

<script>
  import VueAutonumeric from "../../components/AutoNumericNuevo"
  import AutoNumericNuevoWithOptions from "../../components/AutoNumericNuevoWithOptions.vue"
  export default {
    components: {
      VueAutonumeric,
      AutoNumericNuevoWithOptions
    },

    data: () => {
      return {}
    },

    methods: {
      totalesGalones() {
        let totales = {
          gasPremium: 0,
          gasRegular: 0,
          vendido: 0,
        }

        this.cuadre.lecturasMetroCierreList.forEach((lectura) => {
          if (lectura.metro.tipoGas.descripcion.trim().toLowerCase() === "gas regular") {
            totales.gasRegular += lectura.diferencia
          } else if (lectura.metro.tipoGas.descripcion.trim().toLowerCase() === "gas premium") {
            totales.gasPremium += lectura.diferencia
          }
        })
        totales.vendido = totales.gasPremium + totales.gasRegular
        return totales
      },
    },

    props: {
      cuadre: {
        type: Object,
        required: true,
      },
    },

    computed: {
      existenciaEnLibro() {
        this.cuadre.totalexistenciafisica =
          this.cuadre.inventariofisico +
          this.cuadre.comprasdomestico -
          (this.cuadre.salidasgas + this.totalesGalones().vendido)

        return this.cuadre.totalexistenciafisica
      },

      totalDiferencia() {
        this.cuadre.diferenciatotal = this.cuadre.inventariofisicofinal - this.cuadre.totalexistenciafisica
        //return Math.abs(this.cuadre.diferenciatotal)
        return this.cuadre.diferenciatotal
      },
    },
  }
</script>

<style scoped></style>
